import type { LinksFunction } from "@remix-run/node";
import {
  Link as RemixLink,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  isRouteErrorResponse,
  useRouteError,
} from "@remix-run/react";
import { LinkProvider } from "@cprm/shared-ui/components/design/Link";
import stylesheet from "~/tailwind.css?url";

export const links: LinksFunction = () => [
  { rel: "stylesheet", href: stylesheet },
];

export function ErrorBoundary() {
  const error = useRouteError() as Error;
  return (
    <html>
      <head>
        <title>Error</title>
        <Meta />
        <Links />
      </head>
      <body className="flex h-screen w-full">
        <div className="flex-1 bg-blue-700 w-full h-full">
          <div className="flex flex-col items-center justify-center w-full h-full">
            <div className="bg-white max-w-[75vw] p-4 rounded">
              <div className="text-3xl font-bold text-center mt-6">
                Cardio Partners
              </div>
              <div className="text-xl m-4 text-center">Course Confirmation</div>
              <p className="text-center pb-4 font-bold">
                An error occurred. Please contact support.
              </p>
              {isRouteErrorResponse(error) && (
                <p className="max-w-[100%] overflow-auto text-sm">
                  {error.status} {error.statusText}
                </p>
              )}
              {!isRouteErrorResponse(error) && (
                <p className="max-w-[100%] overflow-auto text-sm">
                  {error.message}
                </p>
              )}
            </div>
          </div>
        </div>
        <Scripts />
      </body>
    </html>
  );
}

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return (
    <LinkProvider Link={RemixLink}>
      <Outlet />
    </LinkProvider>
  );
}
